import styled from 'styled-components';
import { Layout } from 'antd';

const { Header: AntHeader } = Layout;

export const HeaderContainer = styled(AntHeader)`
  background: #fff;
  padding: 0 24px;
  border-bottom: 1px solid #f0f0f0;
  position: fixed !important;
  top: 0;
  right: 0;
  left: 80px; /* Espace pour sidebar fermée */
  z-index: 100;
  transition: left 0.2s;
  
  /* Ajuster selon l'état de la sidebar */
  .ant-layout-sider-collapsed ~ * & {
    left: 80px;
  }
  
  .ant-layout-sider:not(.ant-layout-sider-collapsed) ~ * & {
    left: 280px;
  }
`;

export const UserSection = styled.div`
  cursor: pointer;
  padding: 8px 12px;
  border-radius: 8px;
  transition: background-color 0.2s;

  &:hover {
    background-color: #f5f5f5;
  }
`;

export const UserInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin-right: 8px;
`;